// extracted by mini-css-extract-plugin
export default {"header":"UserHeader_header__NhO3U"};